<!--
 * @Author: lijia
 * @Date: 2020-08-04 16:49:37
 * @LastEditTime: 2020-08-08 12:38:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-widget-calc/form-widget-calc.vue
-->
<template>
  <div class="form-widget-calc form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="true"
      >
      <cube-input
          v-if="renderSence === 'edit'"
          class="form-input"
          v-model="formValue"
          :disabled="true"
          :placeholder="widget.readOnly ? '' : widget.placeholder"
          :decimalNum="widget.decimalNum"
          :tabindex="tabindex"
        ></cube-input>
        <span v-if="renderSence === 'read'">{{ formValue || '-' }}</span>
      </x-proxy-form-item>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import WidgetRangeValidator from '../../../form-validator/widget-range-validator'

export default {
  name: 'FormWidgetCalc',
  mixins: [FormWidgetConfigMixin],
  watch: {
    //暂无
  },
  methods: {
    //暂无
  }
}
</script>

<style lang="scss">
  .form-widget-calc{
  }
</style>